module.exports = __webpack_public_path__ + "static/media/Sarthak_Pawar_2.03fbf788.jpg";